<div class="component-box" *ngIf="isSearchVisible">
  <form (ngSubmit)="onSearch()" class="search-form">
    <div class="search-fields">
      <mat-form-field appearance="fill" class="form-field">
        <mat-label>Region</mat-label>
        <mat-select [(ngModel)]="searchForm.region" name="region" placeholder="Region" (selectionChange)="onRegionChange()">
          <mat-option *ngFor="let region of regions" [value]="region.value">
            {{ region.label }}
          </mat-option>
        </mat-select>
        <button *ngIf="searchForm.region" mat-icon-button matSuffix (click)="searchForm.region = undefined; onRegionChange(); $event.stopPropagation()" tabindex="-1">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field appearance="fill" class="form-field">
        <mat-label>Country</mat-label>
        <mat-select [(ngModel)]="searchForm.countryId" name="countryId" placeholder="Country">
          <mat-option *ngFor="let country of countries$ | async" [value]="country.id">
            {{ country.name }}
          </mat-option>
        </mat-select>
        <button *ngIf="searchForm.countryId" mat-icon-button matSuffix (click)="searchForm.countryId = undefined; $event.stopPropagation()" tabindex="-1">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Name</mat-label>
        <input matInput [(ngModel)]="searchForm.fullName" name="fullName" placeholder="Search by name" appTextNormalize>
      </mat-form-field>

      <mat-form-field appearance="fill" class="form-field">
        <mat-label>Category</mat-label>
        <mat-select [(ngModel)]="searchForm.categoryId" name="categoryId" (selectionChange)="onCategoryChange()">
          <mat-option *ngFor="let category of categories$ | async" [value]="category.id">
            {{ category.name }}
          </mat-option>
        </mat-select>
        <button *ngIf="searchForm.categoryId" mat-icon-button matSuffix (click)="searchForm.categoryId = undefined; onCategoryChange(); $event.stopPropagation()" tabindex="-1">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field appearance="fill" class="form-field">
        <mat-label>Sub Category</mat-label>
        <mat-select [(ngModel)]="searchForm.subCategoryId" name="subCategoryId" [disabled]="!searchForm.categoryId" placeholder="Sub Category">
          <mat-option *ngFor="let subCategory of subCategories$ | async" [value]="subCategory.id">
            {{ subCategory.name }}
          </mat-option>
        </mat-select>
        <button *ngIf="searchForm.subCategoryId" mat-icon-button matSuffix (click)="searchForm.subCategoryId = undefined; $event.stopPropagation()" tabindex="-1">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field appearance="fill" class="form-field">
        <mat-label>Year</mat-label>
        <mat-select [(ngModel)]="searchForm.year" name="year" placeholder="Year">
          <mat-option *ngFor="let year of years" [value]="year">
            {{ year }}
          </mat-option>
        </mat-select>
        <button *ngIf="searchForm.year" mat-icon-button matSuffix (click)="searchForm.year = undefined; $event.stopPropagation()" tabindex="-1">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field appearance="fill" class="form-field">
        <mat-label>User</mat-label>
        <mat-select [(ngModel)]="searchForm.createdBy" name="createdBy" placeholder="User">
          <mat-option *ngFor="let user of users$ | async" [value]="user.email">
            {{ user.fullName }}
          </mat-option>
        </mat-select>
        <button *ngIf="searchForm.createdBy" mat-icon-button matSuffix (click)="searchForm.createdBy = undefined; $event.stopPropagation()" tabindex="-1">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <div class="search-actions">
      <mat-checkbox [(ngModel)]="showCompanies" name="showCompanies" color="primary" (change)="onShowCompaniesChange()">Show Companies</mat-checkbox>
      <div class="search-actions-spacer"></div>
      <button mat-flat-button color="primary" type="submit">
        <mat-icon>search</mat-icon>
        Search
      </button>
      <button mat-flat-button type="button" class="nrg-error-flat-button" (click)="clearSearch()">
        <mat-icon>clear</mat-icon>
        Clear
      </button>
    </div>
  </form>
</div>
